module.exports = __webpack_public_path__ + "img/ic-pagosverde.b1e8fb0f.png";